import React from 'react';
import { useGame } from '../context/GameContext';

const ErrorDisplay = () => {
  const { error, setError, translations, lang } = useGame();

  if (!error) return null;

  return (
    <div className="alert alert-danger alert-dismissible fade show error-display-container" role="alert">
      {error}
      <button 
        type="button" 
        className="btn-close" 
        aria-label={translations[lang]?.close_button} 
        onClick={() => setError(null)}
      ></button>
    </div>
  );
};

export default ErrorDisplay;
